import KanbanAreaLine from './KanbanAreaLine'

export default KanbanAreaLine
